<template>
  <section class="n2-portada" v-if="B">
    <div class="n2-contenedor n2-portada__rejilla" :class="{ 'n2-portada__rejilla--sin-media': !media }">
      <div class="n2-portada__texto n2-aparece">
        <img v-if="B.Logo && B.ImagenLogo?.trim()" class="n2-portada__logo" :src="imagenIDtoSRC(B.ImagenLogo)" :alt="'Logo de la ' + NOTARIA.Nombre" />
        <p class="n2-etiqueta">
          <span v-if="abierto !== null" class="n2-estado" :class="abierto ? 'n2-estado--abierto' : 'n2-estado--cerrado'">
            <span class="n2-estado__punto"></span>{{ tSolicitud(abierto ? 'Abierto ahora' : 'Cerrado ahora') }}
          </span>
          <span v-if="C.Municipio">{{ C.Municipio }}</span>
        </p>
        <h1 class="n2-portada__titulo" v-html="B.Titulo?.Texto || NOTARIA.Nombre"></h1>
        <p v-if="B.Subtitulo?.Texto" class="n2-portada__subtitulo" v-html="B.Subtitulo.Texto"></p>
        <div v-if="B.Texto?.Texto" class="n2-portada__parrafo" v-html="B.Texto.Texto"></div>
        <div class="n2-portada__botones">
          <button v-if="B.ShowButtonMoveMenu && B.ButtonMoveMenu?.Texto" type="button" class="n2-boton n2-boton--acento n2-boton--grande"
            @click="ir(B.ButtonMoveMenu.Click, false)">{{ B.ButtonMoveMenu.Texto }}</button>
          <button v-if="B.ShowButtonMoveInicio && B.ButtonMoveInicio?.Texto" type="button" class="n2-boton n2-boton--linea n2-boton--grande"
            @click="ir(B.ButtonMoveInicio.Click, true)">{{ B.ButtonMoveInicio.Texto }}</button>
          <a v-if="!B.ShowButtonMoveMenu && !B.ShowButtonMoveInicio && C.Telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')"
            class="n2-boton n2-boton--acento n2-boton--grande"><v-icon size="18">mdi-phone-outline</v-icon> {{ tSolicitud('Llamar') }}</a>
        </div>
      </div>
      <div v-if="media" class="n2-portada__media n2-aparece">
        <video v-if="esVideo" :src="media" muted autoplay playsinline loop preload="metadata"></video>
        <img v-else :src="media" :alt="NOTARIA.Nombre" fetchpriority="high" :style="{ filter: B.ImagenFiltro || undefined }" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { abiertoAhora, useAccionBanner } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, getFile } = useUtils()

// Panel: Inicio → Banner (mismos textos, imagen o vídeo y botones)
const B = computed(() => NOTARIA.value?.Theme?.Home?.Banner)
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const archivo = computed(() => getFile(B.value?.Imagen))
const esVideo = computed(() => archivo.value?.type === 'video/mp4')
const media = computed(() => B.value?.Imagen ? imagenIDtoSRC(B.value.Imagen) : '')

// La hora depende del visitante: solo en el navegador, para no descuadrar el HTML del servidor
const abierto = ref(null)
onMounted(() => { abierto.value = abiertoAhora(C.value.HorarioEstructurado) })

const ir = useAccionBanner()
</script>
